exports.onClientEntry = () => {
    // @homeaway/react-site-header looks for __ABACUS__ on the window
    window.__ABACUS__ = {};
};
